import { Clickable } from '@ahmdigital/ui';
import React from 'react';
import styled from 'styled-components';

import { scrollToElement } from '../../utils/ui';

const onClickFootnoteLink = (footnoteSymbol: string) => () => {
  scrollToElement(document.getElementById(`footnote-${footnoteSymbol}`));
};

const StyledClickable = styled(Clickable)`
  bottom: 0.325rem;
  font-size: 0.75rem;
  padding-left: 0.25rem;
  position: relative;
  text-decoration: none;
`;

type FootnoteLinkProps = {
  footnoteSymbol: string;
};

const FootnoteLink = ({ footnoteSymbol }: FootnoteLinkProps) => (
  <StyledClickable onClick={onClickFootnoteLink(footnoteSymbol)}>{footnoteSymbol}</StyledClickable>
);

export default FootnoteLink;
